import { get } from 'services/api';

const receiveCustomization = (data: any) => ({
  type: 'RECEIVE_CUSTOMIZATION',
  customizationData: data,
});

export const cleanCustomization = () => (dispatch: any) => {
  dispatch({
    type: 'CLEAN_CUSTOMIZATION',
  });
};

export const requestCustomization = (courseHash: string) => async (dispatch: any, getState: Function) => {
  const customization = getState().customization;
  const customizationData = customization.customizationData || {};
  const currentCustomizationCourseHash = customization.customizationData.hash || customizationData.requesting;
  if (currentCustomizationCourseHash === courseHash) {
    return;
  }
  dispatch(
    receiveCustomization({
      requesting: courseHash,
    })
  );
  const res = await get({ url: `/learner/course/${courseHash}/customization?` });
  dispatch(
    receiveCustomization({
      hash: courseHash,
      ...res.data.data,
    })
  );
};
